<template>
  <div
    role="application"
    aria-label="Sketch color picker"
    :class="['vc-sketch', disableAlpha ? 'vc-sketch__disable-alpha' : '']"
  >
    <div class="vc-sketch-saturation-wrap">
      <saturation :value="colors" @change="childChange"></saturation>
    </div>
    <div class="vc-sketch-controls vc-sketch-controls-box">
      <div class="vc-sketch-sliders">
        <div class="vc-sketch-hue-wrap vc-sketch-first-slider">
          <hue :value="colors" @change="childChange"></hue>
        </div>
        <div class="vc-sketch-alpha-wrap vc-sketch-second-slider" v-if="!disableAlpha">
          <alpha :value="colors" @change="childChange"></alpha>
        </div>
      </div>

      <div class="vc-sketch-color-wrap-box" :style="{'height': disableAlpha ? '14px' :'36px'}">
        <div class="vc-sketch-color-wrap">
          <div
            :aria-label="`Current color is ${activeColor}`"
            class="vc-sketch-active-color"
            :style="{ background: activeColor }"
          ></div>
          <checkboard></checkboard>
        </div>
        <div v-if="!disableAlpha" class="vc-sketch-alpha-box">{{ percentColor }}</div>
      </div>
    </div>

    <div class="vc-sketch-field-box">
      <div class="left-box" >
        <svg @click="$emit('strawClick',$event)" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><defs></defs><rect class="a" width="22" height="22"/><path class="b" d="M419.49,202.52a1.78,1.78,0,0,0-2.514,0h0l-1.694,1.71-1.344-1.372a1.123,1.123,0,1,0-1.592,1.585l.7.7-8.526,8.493-.293,1.946-1.785,1.721a1.594,1.594,0,0,0,2.259,2.249l1.727-1.721,1.942-.348,8.512-8.493.711.7a1.124,1.124,0,0,0,1.593-1.586l-1.411-1.394,1.682-1.676a1.763,1.763,0,0,0,.051-2.492l-.017-.017ZM411.4,212.779h-4.423l6.865-6.839,2.258,2.249Z" transform="translate(-400 -200)"/></svg>
        <img v-if="false" @click="$emit('strawClick',$event)" width="28" :src="require('@qcolor/assets/icon_style_straw.png')" />
      </div>

      <div class="vc-sketch-field" v-if="!disableFields">
        <!-- rgba -->

        <div class="vc-sketch-field--single">
          <ed-in label="r" :value="colors.rgba.r" @change="inputChange"></ed-in>
        </div>
        <div class="vc-sketch-field--single">
          <ed-in label="g" :value="colors.rgba.g" @change="inputChange"></ed-in>
        </div>
        <div class="vc-sketch-field--single">
          <ed-in label="b" :value="colors.rgba.b" @change="inputChange"></ed-in>
        </div>
        <div class="vc-sketch-field--double">
          <ed-in label="hex" :value="hex" @change="inputChange"></ed-in>
        </div>
        <!-- <div class="vc-sketch-field--single" v-if="!disableAlpha">
        <ed-in label="a" :value="colors.a" :arrow-offset="0.01" :max="1" @change="inputChange"></ed-in>
      </div> -->
      </div>
    </div>

    <div
      class="vc-sketch-presets"
      v-if="false"
      role="group"
      aria-label="A color preset, pick one to set as current color"
    >
      <template v-for="c in presetColors">
        <div
          :key="`!${c}`"
          v-if="!isTransparent(c)"
          class="vc-sketch-presets-color"
          :aria-label="'Color:' + c"
          :style="{ background: c }"
          @click="handlePreset(c)"
        ></div>
        <div
          v-else
          :key="c"
          :aria-label="'Color:' + c"
          class="vc-sketch-presets-color"
          @click="handlePreset(c)"
        >
          <checkboard />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import colorMixin from "@qcolor/mixin/color";
import editableInput from "@qcolor/components/editable-input/editable-input.vue";
import saturation from "@qcolor/components/saturation/saturation.vue";
import hue from "@qcolor/components/hue/hue.vue";
import alpha from "@qcolor/components/alpha/alpha.vue";
import checkboard from "@qcolor/components/checkboard/checkboard.vue";
const presetColors = [
  "#D0021B",
  "#F5A623",
  "#F8E71C",
  "#8B572A",
  "#7ED321",
  "#417505",
  "#BD10E0",
  "#9013FE",
  "#4A90E2",
  "#50E3C2",
  "#B8E986",
  "#000000",
  "#4A4A4A",
  "#9B9B9B",
  "#FFFFFF",
  "rgba(0,0,0,0)",
];

export default {
  name: "Sketch",
  mixins: [colorMixin],
  data() {
    return {
    };
  },
  components: {
    saturation,
    hue,
    alpha,
    "ed-in": editableInput,
    checkboard,
  },
  props: {
    presetColors: {
      type: Array,
      default() {
        return presetColors;
      },
    },
    disableAlpha: {
      type: Boolean,
      default: false,
    },
    disableFields: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hex() {
      let hex;
      if (this.colors.a < 1) {
        hex = this.colors.hex8;
      } else {
        hex = this.colors.hex;
      }
      return hex
      //return hex.replace("#", "");
    },
    activeColor() {
      const { rgba } = this.colors;
      return `rgba(${[rgba.r, rgba.g, rgba.b, rgba.a].join(",")})`;
    },
    percentColor() {
      let percent = Number(this.colors.a * 100).toFixed(0);
      percent += "%";
      return percent;
    },
  },
  methods: {
    handlePreset(c) {
      this.colorChange(c);
    },
    childChange(data) {
      this.colorChange(data);
    },
    inputChange(data) {
      if (!data) {
        return;
      }
      if (data.hex || data.HEX) {
        this.isValidHex(data.hex ? data.hex : data.HEX) &&
          this.colorChange({
            hex: data.hex,
            source: "hex",
          });
      } else if (data.r || data.g || data.b || data.a) {
        this.colorChange({
          r: data.r || this.colors.rgba.r,
          g: data.g || this.colors.rgba.g,
          b: data.b || this.colors.rgba.b,
          a: data.a || this.colors.rgba.a,
          source: "rgba",
        });
      }
    },
  },
};
</script>

<style lang="scss">
.vc-sketch {
  position: relative;
  // width: 200px;
  //padding: 10px 10px 0;
  box-sizing: initial;
  //background: #fff;
  border-radius: 4px;
  width: 100%;
  //box-shadow: 0 0 0 1px rgba(0, 0, 0, .15), 0 8px 16px rgba(0, 0, 0, .15);
}

.vc-sketch-saturation-wrap {
  width: 100%;
  height: 159px;
  border-radius: 4px;
  //padding-bottom: 75%;
  position: relative;
  overflow: hidden;
}

.vc-sketch-controls {
  display: flex;
}

.vc-sketch-sliders {
  padding: 4px 0;
  flex: 1;
  > .vc-sketch-first-slider {
    height: 14px;
    .vc-hue-picker {
      margin-top: 1px;
      box-sizing: border-box;
      // height: 14px;
      // width: 14px;
      // border: 3px solid white;
      // border-radius: 50%;
      // transform: translateX(-4px);
      // background-color: #02adb3;


      height: 12px;
      width: 6px;
      //transform: translateX(-4px);
      background: #FFFFFF;
      box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.5);
      border-radius: 10px 10px 10px 10px;
    }
  }
}

.vc-sketch-sliders .vc-hue,
.vc-sketch-sliders .vc-alpha-gradient {
  border-radius: 4px;
}

.vc-sketch-hue-wrap {
  position: relative;
  height: 10px;
}

.vc-sketch-alpha-wrap {
  position: relative;
  height: 14px;
  //margin-top: 4px;
  overflow: hidden;
}

.vc-sketch-color-wrap-box {
  width: 32px;
  padding: 4px 0;
  margin-left: 10px;
  >.vc-sketch-color-wrap{
    height: 14px;
    width: 100%;
  }
  > .vc-sketch-alpha-box {
    //height: 10px;
    font-size: 10px;
    background-color:$control_color_4;
    text-align: center;
    border-radius: 4px;
    position: relative;
    top: 2px;
  }
}

.vc-sketch-color-wrap {
  width: 24px;
  height: 10px; //24px
  position: relative;
  // margin-top: 4px;
  // margin-left: 4px;
  // border-radius: 3px;
}

.vc-sketch-active-color {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 4px;
  // box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15),
  //   inset 0 0 4px rgba(0, 0, 0, 0.25);
  z-index: 2;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.vc-sketch-color-wrap .vc-checkerboard {
  background-size: auto;
}

.vc-sketch-field {
  display: flex;
  flex-grow: 1;
  justify-content:space-between;
  //padding-top: 4px;
}

.vc-sketch-field .vc-input__input {
  width: 100%;
  border: none;
  box-shadow:none;
  height: 26px;
  line-height: 26px;
  background: #F8F8FC;
  border-radius: 4px 4px 4px 4px;
  text-align: center;
  font-size: 12px;
  background-color: $control_color_4;
  color:$font_color_main;
  &:hover {
    background: rgba(8, 35, 110, 0.06);
  }
  // padding: 4px 0 3px 10%;
  // border: none;
  // box-shadow: inset 0 0 0 1px #ccc;
  // font-size: 10px;
}

.vc-sketch-field .vc-input__label {
  display: block;
  text-align: center;
  font-size: 12px;
  color: $font_color_light;
  padding-top: 3px;
  //padding-bottom: 4px;
  text-transform: capitalize;
}

.vc-sketch-field--single {
  width: 32px;
  //flex: 1;
  //padding-left: 6px;
  &:first-of-type {
    padding-left: 0;
  }
  //margin-right: 8px;
}

.vc-sketch-field--double {
  width: 74px;
  //padding-left: 6px;
}

.vc-sketch-presets {
  margin-right: -10px;
  margin-left: -10px;
  padding-left: 10px;
  padding-top: 10px;
  border-top: 1px solid #eee;
}

.vc-sketch-presets-color {
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin: 0 10px 10px 0;
  vertical-align: top;
  cursor: pointer;
  width: 16px;
  height: 16px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15);
}

.vc-sketch-presets-color .vc-checkerboard {
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15);
  border-radius: 3px;
}

.vc-sketch__disable-alpha .vc-sketch-color-wrap {
  height: 10px;
}

.vc-sketch-field-box {
  display: flex;
  > .left-box {
    flex-shrink: 0;
    margin-right: 12px;
    >svg { 
      cursor: pointer;
    }
    .a { 
      fill:none;
    }
    .b { 
      fill:$icon_color;
    }
    >img {
      cursor: pointer;
    }
  }
}


.vc-sketch-controls-box{
  margin: 10px 0 10px 0;
  >.vc-sketch-sliders{
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .vc-sketch-second-slider{
      border-radius: 4px;
      position: relative;
      //top: -4px;
    }
  }
  >.vc-sketch-color-wrap-box{
    height: 36px;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    >.vc-sketch-color-wrap{
      height: 14px;
    }
  }
}

</style>
